<template>
  <div>
    <div v-if="!showPlan">
      <div class="flex sidebar-topfixpart bg-primary p-4">
        <feather-icon
          icon="ChevronLeftIcon"
          @click="isSidebarActiveLocal = false"
          class="cursor-pointer text-white"
          svgClasses="w-6"
        ></feather-icon>
        <h2 class="h2-class font-semibold text-white pl-4">ADD DISCUSSION</h2>
      </div>
      <div class="p-4">
        <div class="mb-4">
          <FileUploader />
        </div>
        <div class="">
          <b-input placeholder="Title" class="form-control-muted mb-4" />
          <b-input placeholder="Description" class="form-control-muted mb-4" />
          <base-input
            type="date"
            value="Description Start Date"
            id="example-date-input"
            class="form-control-muted mb-4"
          />
          <base-input
            class="form-control-muted mb-4"
            type="date"
            value="Description End Date"
            id="example-date-input2"
          />
        </div>
      </div>
      <footer
        class="
          footer-fix
          md:fixed
          lg:fixed
          bottom-0
          md:w-1/4
          lg:w-1/4
          w-full
          mobile-sidebarfooter
        "
      >
        <base-button
          block
          type="primary"
          class="rounded-none font-semibold"
          @click="showPlan = true"
          >CHOOSE CHANNEL</base-button
        >
      </footer>
    </div>
    <div class="mb-4" v-show="showPlan">
      <ChoosePlan />
    </div>
  </div>
</template>
<script>
import FileUploader from "@/components/FileUploader.vue";
import ChoosePlan from "./ChoosePlan.vue";
export default {
  components: {
    FileUploader,
    ChoosePlan,
  },
  data() {
    return {
      showPlan: false,
    };
  },
};
</script>
